import { z } from "zod";

/**
 * AtributosSistemaFormSchema
 */

export const AtributosSistemaFormSchema = z.object({
  idAtributoSistema: z.number().int().nonnegative().default(0),
  limparArquivo: z.boolean().optional().default(false),
  nomeCliente: z.string().nullable().default(null),
  logoCliente: z.instanceof(File).nullable().default(null),
  extensaoLogo: z.string().nullable().default(null),

});

export type AtributosSistemaForm = z.infer<typeof AtributosSistemaFormSchema>;

export const AtributosSistemaFormDefaultValues: AtributosSistemaForm = {
  idAtributoSistema: 0,
  limparArquivo: false,
  nomeCliente: null,
  logoCliente: null,

  extensaoLogo: null,

};